import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { performRequest } from './actions.mjs';
import ArticleFilters from './ArticleFilters';
import ArticleTags from './ArticleTags';
import ArticleItem from './ArticleItem';

class ArticleFiltering extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <ArticleFilters />
                        <ArticleTags />
                    </div>
                </div>

                <div className="row" id={this.props.sectionid}>
                    {this.props.topicalHits.map(hit => {
                        return <ArticleItem hit={hit} key={hit.contentLink} />;
                    })}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        topicalHits: state.results.topicalHits,
        categories: state.results.hitCategories,
        tags: state.results.hitTags,
        category: state.category,
        loading: state.loading
    };
}

export default connect(mapStateToProps)(ArticleFiltering);
